<app-shared-dialog
  [title]="(isUpdate ? 'knowledge_base.aliases.dialog.title_edit' : 'knowledge_base.aliases.dialog.title_create') | translate"
  [options]="{
    cancelText: 'common.cancel' | translate,
    customConfirmButton: true
  }"
  (cancel)="close()"
>
  <form class="information-form" [formGroup]="form">
    <div class="form-content">
      <!-- Description -->
      <p class="add-alias__description">
        {{ "knowledge_base.aliases.dialog.description" | translate }}
      </p>

      <!-- Product (autocomplete with server-side search) -->
      <div class="standard-input">
        <label>{{ "knowledge_base.aliases.dialog.product" | translate }}</label>
        <div class="autocomplete-wrapper">
          <input
            type="text"
            class="is-autocomplete"
            [disabled]="!(canSubmit$ | async)"
            [formControl]="productSearchControl"
            [matAutocomplete]="productAuto"
            [placeholder]="'knowledge_base.aliases.dialog.product_placeholder' | translate"
          />
          <button
            *ngIf="productSearchControl.value && (canSubmit$ | async)"
            type="button"
            class="autocomplete-clear"
            (click)="clearProduct(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-autocomplete #productAuto="matAutocomplete" [displayWith]="displayProductFn" (optionSelected)="onProductSelected($event.option.value)">
          <mat-option *ngIf="productSearchState === 'idle'" disabled>
            {{ "knowledge_base.aliases.dialog.start_typing" | translate }}
          </mat-option>
          <mat-option *ngFor="let product of filteredProducts$ | async" [value]="product">
            {{ product.label }}
          </mat-option>
          <mat-option *ngIf="productSearchState === 'results' && (filteredProducts$ | async)?.length === 0" disabled>
            {{ "knowledge_base.aliases.dialog.no_products" | translate }}
          </mat-option>
        </mat-autocomplete>
        <div class="error" *ngIf="form.get('sku')?.invalid && (form.get('sku')?.touched || form.get('sku')?.dirty)">
          <small *ngIf="form.get('sku')?.hasError('required')">{{ "validation.required" | translate }}</small>
        </div>
      </div>

      <!-- Alias -->
      <div class="standard-input">
        <label>{{ "knowledge_base.aliases.dialog.alias_value" | translate }}</label>
        <ui-form-field
          type="text"
          formControlName="alias_value"
          [disabled]="!(canSubmit$ | async)"
          [placeholder]="'knowledge_base.aliases.dialog.alias_value_placeholder' | translate"
          [errorMessages]="{ required: ('validation.required' | translate) }"
        >
        </ui-form-field>
      </div>

      <!-- Alias type (optional) -->
      <div class="standard-input">
        <label
          >{{ "knowledge_base.aliases.dialog.type" | translate }} <span class="add-alias__optional">{{ "common.optional" | translate }}</span></label
        >
        <ui-form-field
          type="select"
          [options]="aliasTypeOptions"
          formControlName="alias_type"
          [disabled]="!(canSubmit$ | async)"
          [placeholder]="'knowledge_base.aliases.dialog.type_placeholder' | translate"
        >
        </ui-form-field>
      </div>

      <!-- Customer (autocomplete with server-side search) -->
      <div class="standard-input">
        <label
          >{{ "knowledge_base.aliases.dialog.customer" | translate }}
          <span class="add-alias__optional">{{ "common.optional" | translate }}</span></label
        >
        <div class="autocomplete-wrapper">
          <input
            type="text"
            class="is-autocomplete"
            [disabled]="!(canSubmit$ | async)"
            [formControl]="customerSearchControl"
            [matAutocomplete]="customerAuto"
            [placeholder]="'knowledge_base.aliases.dialog.customer_placeholder' | translate"
          />
          <button
            *ngIf="customerSearchControl.value && (canSubmit$ | async)"
            type="button"
            class="autocomplete-clear"
            (click)="clearCustomer(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-autocomplete
          #customerAuto="matAutocomplete"
          [displayWith]="displayCustomerFn"
          (optionSelected)="onCustomerSelected($event.option.value)"
        >
          <mat-option *ngIf="customerSearchState === 'idle'" disabled>
            {{ "knowledge_base.aliases.dialog.start_typing" | translate }}
          </mat-option>
          <mat-option *ngFor="let customer of filteredCustomers$ | async" [value]="customer">
            {{ customer.label }}
          </mat-option>
          <mat-option *ngIf="customerSearchState === 'results' && (filteredCustomers$ | async)?.length === 0" disabled>
            {{ "knowledge_base.aliases.dialog.no_customers" | translate }}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </form>
  <ui-button
    customConfirm
    *appHasPermission="submitPermission()"
    type="primary"
    [label]="(isUpdate ? 'common.update' : 'common.create') | translate"
    icon="arrow-right"
    iconPosition="end"
    (click)="save()"
  >
  </ui-button>
</app-shared-dialog>
